import type { PlatformAdapter } from "./adapter";
import { createCrazyGamesAdapter } from "./crazygames";
import { createLocalAdapter } from "./local";

export type { AdPlacement, PlatformAdapter, PlatformEnvironment } from "./adapter";
export { linksOutside, PATREON_URL } from "./links";

/**
 * Picks the adapter from the build-time VITE_PLATFORM variable. Runtime
 * detection of the CrazyGames host belongs inside crazygames.ts, later.
 */
export function selectAdapter(): PlatformAdapter {
  const platform = import.meta.env.VITE_PLATFORM ?? "local";
  switch (platform) {
    case "crazygames":
      return createCrazyGamesAdapter();
    case "local":
      return createLocalAdapter();
    default:
      throw new Error(`Unknown VITE_PLATFORM: ${String(platform)}`);
  }
}
